import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-about-intro-redesign',
  templateUrl: './about-intro-redesign.component.html',
  styleUrls: ['./about-intro-redesign.component.scss']
})
export class AboutIntroRedesignComponent {

    @Input() title = 'Revolutionizing Patient Care with Smart Monitoring Solutions';

    @Input() paragraphs: string[] = [
        'Althea Soft is a clinical AI company developing intelligent software for hospitals, clinics, public health systems and multidisciplinary care teams.',

        'Our real-time Shared Patient Data & Collaborative Care platform is designed to empower healthcare teams with intelligent tools for enhanced patient care. It helps institutions move beyond fragmented and reactive models of mental healthcare by connecting clinical teams, monitoring patient evolution in real time and supporting earlier, better-informed decisions.',

        'Mental health systems are often limited by disconnected departments, delayed information and lack of continuous visibility. Althea Soft was created to address this gap with a more predictive, coordinated and data-driven approach.'
    ];

    @Input() darkBackground = false;

    trackByIndex(index: number): number {
        return index;
    }

}